"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = require("react");
var react_dom_1 = require("react-dom");
/**
 * A Portal component which automatically closes itself
 * when certain events happen outside.
 * See https://reactjs.org/docs/portals.html.
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portal = document.createElement('div');
        _this.onCloseEvent = _this.onCloseEvent.bind(_this);
        return _this;
    }
    Portal.prototype.onCloseEvent = function (e) {
        var onClose = this.props.onClose;
        if (!this.portal.contains(e.target)) {
            onClose();
        }
    };
    Portal.prototype.componentDidMount = function () {
        var _a = this.props, node = _a.node, onClose = _a.onClose, closeOnClick = _a.closeOnClick, closeOnType = _a.closeOnType, closeOnResize = _a.closeOnResize;
        node.appendChild(this.portal);
        if (closeOnClick) {
            document.addEventListener('mouseup', this.onCloseEvent);
        }
        if (closeOnType) {
            document.addEventListener('keyup', this.onCloseEvent);
        }
        if (closeOnResize) {
            window.addEventListener('resize', onClose);
        }
    };
    Portal.prototype.componentWillUnmount = function () {
        var _a = this.props, node = _a.node, onClose = _a.onClose;
        node.removeChild(this.portal);
        document.removeEventListener('mouseup', this.onCloseEvent);
        document.removeEventListener('keyup', this.onCloseEvent);
        window.removeEventListener('resize', onClose);
    };
    Portal.prototype.render = function () {
        var children = this.props.children;
        return react_dom_1.createPortal(children, this.portal);
    };
    return Portal;
}(react_1.Component));
Portal.propTypes = {
    onClose: prop_types_1["default"].func.isRequired,
    node: prop_types_1["default"].instanceOf(Element),
    children: prop_types_1["default"].node,
    closeOnClick: prop_types_1["default"].bool,
    closeOnType: prop_types_1["default"].bool,
    closeOnResize: prop_types_1["default"].bool,
};
Portal.defaultProps = {
    node: document.body,
    children: null,
    closeOnClick: false,
    closeOnType: false,
    closeOnResize: false,
};
exports["default"] = Portal;
